import {Modal} from "antd";
import React from "react";
import icon from "../../../assets/images/modal-icon-offer.svg";
import {FormValuesCCSaveExtended} from "../../../core/models/custom/formValuesCCSaveExtended";
import {OfferValue} from "../../../core/models/custom/offerValue";
import {MeDto} from "../../../core/models/dtos/me.dto";
import {ApiEvent} from "../../../core/models/enums/apiEvent";
import {apiEventRequest} from "../../../core/services/eventService/apiEvent/repository";
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import {Helpers} from "../../../core/utilities/helpers";
import {UI} from "../../../core/utilities/ui";
import FirebaseKey from "../../FirebaseKey/FirebaseKey";
import CCSaveForm from "./CCSaveForm/CCSaveForm";
import "./CCSaveModal.scss";

interface IProps {
  me?: MeDto;
  offer: OfferValue;
  isLoading: boolean;
  callback: (values?: FormValuesCCSaveExtended) => void;
}

const CCSaveModal = (props: IProps) => {
  const isNewcomer = !props.me?.firstTimeSavedCardDate;
  
  const handleSubmit = (values?: FormValuesCCSaveExtended): void => {
    if (values) {
      apiEventRequest({
        ...Helpers.getApiEventCoreData(props.me),
        event: ApiEvent.SAVE_CARD_REQUEST,
        value1: props.offer.id,
      }).catch();
    }
    props.callback(values)
  }
  
  const renderContent = () => {
    let titleKey = FirebaseService.save_card_header;
    let textKey = FirebaseService.save_card_description;
    if (isNewcomer) {
      titleKey = FirebaseService.cc_save_card_first_time_header;
      textKey = FirebaseService.cc_save_card_first_time_description;
    }
    return (
      <>
        <FirebaseKey className="title" firebaseKey={titleKey}/>
        <FirebaseKey className="text" firebaseKey={textKey}/>
      </>
    );
  }
  
  return (
    <Modal
      className="cc-save-modal"
      maskStyle={UI.modalMaskStyle()}
      visible
      closable={false}
      footer={false}
      centered
      destroyOnClose
    >
      <div className="content">
        <img className="icon" src={icon} alt="icon"/>
        {renderContent()}
        <CCSaveForm
          isNewcomer={isNewcomer}
          isLoading={props.isLoading}
          callbackSubmit={handleSubmit}
        />
      </div>
    </Modal>
  );
}

export default CCSaveModal;
